// extracted by mini-css-extract-plugin
export default {"introContainer":"introduction_introContainer__A1y65"};